import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { Event } from '@ifeng/ui_base';
import styles from './index.css';
import Tabs from './tabs/';
import LeftBar from './leftBar/';
import RightBar from './rightBar/';
import MapShowMode from './mapShowMode.json';
import { getSportsStreamInitData, getCustomData } from '../../../../../services/api.js';
import { getCommentNum } from '../../../../../utils/getCommentNum';
import { handleAd } from '../../../../../utils/handleAd';

const TabsNewsStream = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
            rightAdData: PropTypes.object,
            streamAdData: PropTypes.object,
        };

        constructor(props) {
            super(props);
            const {
                content: { initTab_right_lqd, initTab_right_ycch, initTab_right_rdzt },
            } = props;

            // 这不分数据不需要请求评论
            const leftBarData = [];

            this.event = new Event();

            this.state = {
                current: 0,
                leftMode: MapShowMode[0].left,
                rightMode: MapShowMode[0].right,
                leftBarData,
                rightBarData: {
                    initTab_right_lqd,
                    initTab_right_ycch,
                    initTab_right_rdzt,
                    initTab_right_sc: [],
                    initTab_right_jfb: [],
                },
                isEnd: [false, false, false, false, false, false],
                page: [1, 1, 1, 1, 1, 1],
                initInsertAd: [true, true, true, true, true, true],
            };
        }

        getData = async (currentTab, currentPage) => {
            const initNewsStreamData = await getSportsStreamInitData(
                MapShowMode[currentTab].streamType,
                MapShowMode[currentTab].streamKey,
                currentPage,
            );

            return initNewsStreamData.data;
        };

        getRightCustomData = async current => {
            if (MapShowMode[current].rightData) {
                const res_sc = await getCustomData(MapShowMode[current].rightData.sc.dataKey);
                const res_jfb = await getCustomData(MapShowMode[current].rightData.jfb.dataKey);

                const { rightBarData } = this.state;

                if (Object.prototype.toString.call(res_sc.data) === '[object Object]') {
                    res_sc.data = [res_sc.data];
                }

                if (Object.prototype.toString.call(res_jfb.data) === '[object Object]') {
                    res_jfb.data = [res_jfb.data];
                }

                this.setState({
                    rightBarData: {
                        ...rightBarData,
                        initTab_right_sc: res_sc.data || [],
                        initTab_right_jfb: res_jfb.data || [],
                    },
                });
            }
        };

        // 兼容 ie7 的 offsetTop 获取方法
        getOffsetTop = dom => {
            let offsetTop = dom.offsetTop;

            if (dom.offsetParent) {
                offsetTop += this.getOffsetTop(dom.offsetParent);
            }

            return offsetTop;
        };

        scrollTop = () => {
            const tabBox = document.getElementById('tabSwitch');
            const offsetTop = this.getOffsetTop(tabBox);

            this.tabsTop = document.getElementById('tabSwitch').offsetTop || offsetTop;
            // 兼容各主流浏览器
            const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            if (currentTop > this.tabsTop) {
                scrollTo(0, this.tabsTop);
            }
        };

        /**
         * 初始化tab切换
         */
        handleTabSwitch = async current => {
            const { leftBarData, isEnd, page, initInsertAd } = this.state;

            if (!leftBarData[current]) {
                const res = await this.getData(current, page[current]);

                const getComments = await getCommentNum(res);

                if (res.length < 20) {
                    isEnd[current] = true;
                } else {
                    isEnd[current] = false;
                }

                leftBarData[current] = getComments;
            }

            this.setState({
                current,
                leftMode: MapShowMode[current].left,
                rightMode: MapShowMode[current].right,
                isEnd,
                leftBarData,
                tabfixed: true,
            });
            this.getRightCustomData(current);
            this.scrollTop();
            if (initInsertAd[current]) {
                await this.insertAD(current, 'init');
            }
        };

        streamGetMore = async () => {
            const { current, page, leftBarData, isEnd } = this.state;

            if (page[current] < MapShowMode[current].streamLimit) {
                const moreData = await this.getData(current, page[current] + 1);
                const getComments = await getCommentNum(moreData);

                if (getComments.length < 20 || page[current] === MapShowMode[current].streamLimit - 1) {
                    isEnd[current] = true;
                    this.setState({
                        isEnd,
                    });
                }

                let newPage = [];
                let newLeftBarData = [];

                newPage = [...page];
                newLeftBarData = [...leftBarData];

                newPage[current] = page[current] + 1;
                newLeftBarData[current] = [...leftBarData[current], ...getComments];

                this.setState({
                    page: newPage,
                    leftBarData: newLeftBarData,
                });
                if (getComments.length > 0) {
                    this.insertAD(current, 'loadMoreCmp');
                }
            } else {
                let newIsEnd = [];

                newIsEnd = [...isEnd];

                newIsEnd[current] = true;

                this.setState({
                    isEnd: newIsEnd,
                });
            }
        };

        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { leftBarData, current } = this.state;
                const infoData = [...leftBarData[current]];

                // 只是切换tab时不需要重复插入
                const refs = [];

                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 0, { type: 'ad', ref });
                });

                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                });

                // 广告数据整合处理完毕后，更新列表数据
                let newLeftBarData = [];

                newLeftBarData = [...leftBarData];

                newLeftBarData[current] = [...infoData];
                this.setState(
                    {
                        leftBarData: newLeftBarData,
                    },
                    () => {
                        const dom = {};

                        for (const ref of refs) {
                            dom[ref.index] = ref.ref.current;
                        }

                        adFn(dom);
                    },
                );
            }

            return;
        };

        insertAD = async (current, type) => {
            const { initInsertAd, leftBarData } = this.state;

            if (initInsertAd[current] && type === 'init') {
                try {
                    this.adInit({ index: current, len: leftBarData[current].length });
                } catch (e) {
                    console.error(e);
                }
                const newInsertAdState = [...initInsertAd];

                newInsertAdState[current] = false;
                this.setState({
                    initInsertAd: newInsertAdState,
                });
            }

            if (type === 'loadMoreCmp') {
                try {
                    this.adLoadMore({ index: current, len: leftBarData[current].length });
                } catch (e) {
                    console.error(e);
                }
            }
        };

        async componentDidMount() {
            const {
                content: { initTab_left_newStream },
            } = this.props;

            const { current } = this.state;

            const addComment = await getCommentNum(initTab_left_newStream);

            const newLeftBarData = [];

            newLeftBarData.push([...addComment]);

            this.setState({
                leftBarData: newLeftBarData,
            });

            try {
                const { streamAdData } = this.props;
                // 测试数据
                // const streamAdData = {
                //     data: {},
                //     preload: '',
                //     callback: function(data, event, insert) {
                //         // event 为传入的 event 事件对象，用于广告方绑定事件
                //         // insert 为我们自定义的广告插入方法
                //         event.on('init', function(data) {
                //             console.log(data);
                //             // data 为我们触发方法时传参值
                //             const insertArr = [0, 4];

                //             const replaceArr = [];

                //             insert(insertArr, replaceArr, function(dom) {});
                //         });
                //         event.on('loadMoreCmp', function(data) {
                //             console.log(data);
                //             // data 为我们触发方法时传参值
                //             const insertArr = [2, 3];

                //             const replaceArr = [];

                //             insert(insertArr, replaceArr, function(dom) {});
                //         });
                //     },
                // };
                const callback = await handleAd(streamAdData);

                // 将自定义广告插入方法传入，这样广告方即可调用
                callback(streamAdData.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            await this.insertAD(current, 'init');
        }

        adInit = data => {
            try {
                // 触发广告位插入方法
                this.event.trigger('init', data);
            } catch (e) {
                console.error(e);
            }
        };

        adLoadMore = data => {
            try {
                // 触发广告位插入方法
                this.event.trigger('loadMoreCmp', data);
            } catch (e) {
                console.error(e);
            }
        };

        render() {
            const { leftBarData, current, isEnd, rightBarData } = this.state;

            const {
                content: { streamOrderArr },
            } = this.props;

            return (
                <div className={styles.tabsNewsBox} id="tabSwitch">
                    <Tabs callback={this.handleTabSwitch} />
                    <LeftBar
                        pureStream={leftBarData}
                        mixStream={streamOrderArr}
                        isEnd={isEnd[current]}
                        current={current}
                        getMore={this.streamGetMore}
                        id="stream"
                    />
                    <RightBar
                        content={rightBarData}
                        mode={MapShowMode[current].right}
                        current={current}
                        adData={this.props.rightAdData}
                    />
                </div>
            );
        }
    },
);

export { TabsNewsStream };
export default TabsNewsStream;
